import invariant from 'invariant';
import queryString from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

type Config = {
    baseUrl: string;
    brandId: string;
    country: string;
    uberToken: string;
    clientId: string;
    clientSecret: string;
    options?: Record<string, string>;
};

const getCategories: (config: Config) => Promise<unknown> = (config) => {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, options } = config;

    invariant(baseUrl, 'baseUrl is a required param of getCategories()');
    invariant(brandId, 'brandId is a required param of getCategories()');
    invariant(country, 'country is a required param of getCategories()');
    invariant(clientId, 'clientId is a required param of getCategories()');

    const headers = { 'Content-Type': 'application/json' };

    const queries = options ? `?${queryString.stringify(options)}` : '';
    const fetchUrl = `${baseUrl}search/resources/store/${brandId}_${country.toLowerCase()}/categoryview/@top${queries}`;

    return labelRequest(
        authenticatedRequest(new Request(fetchUrl, { headers: new Headers(headers), method: 'GET' }), uberToken, clientId, clientSecret),
        'getCategories',
    );
};

export default getCategories;
